import { module } from "modujs";
import formStepsMixin from "../vue-mixins/formStepsMixin";
import {isDebug} from "../utils/environment";

const STATE = {
    IDLE: 'IDLE',       // Form is ready
    PROCESSING: 'PROCESSING', // Form is being processed
    TESTING: 'TESTING',    // Form is being tested
    SENDING: 'SENDING',    // Form is being sent and awaiting response
    INVALID: 'INVALID',    // Form is invalid (HTTP 400)
    ERRORED: 'ERRORED',    // Form can not be processed (HTTP 500)
    COMPLETED: 'COMPLETED',  // Form was processed successfully (HTTP 201)
}

const GENERIC_MESSAGES = {
    critical: 'Une erreur critique s’est produite. Veuillez réessayer plus tard ou nous contacter ici',
    redirect: 'Il s’est produit une erreur prévenant la redirection du formulaire. Il est fort probable que la soumission sois quand même valide. Dans le cas contraire, veuillez réessayer plus tard ou nous contacter ici'
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Initial values are used to prefill the form.
        this.initialValues = JSON.parse(this.getData('values'))
        // Init vue
        this.initVue();
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default);
        const { required, maxLength, email, sameAs } = window.validators;

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            mixins: [formStepsMixin],

            data: () => {
                return {
                    submitStatus: '',

                    step1: {
                        thematics: []
                    },

                    step2: {
                        industries: []
                    },
                };
            },

            validations: {
                step1: {
                    thematics: {}
                },

                step2: {
                    industries: {}
                },
            },

            created() {
                this.moduleInstance = moduleInstance;
                // Set initial values
                this.moduleInstance.initialValues && this.setInitialValues(this.moduleInstance.initialValues)
            },

            methods: {
                submit(event) {
                    this.$v.$touch();
                    const form = event.target
                    const formUrl = form.action
                    const formData = new FormData(form)
                    const controller = new AbortController();

                    let responseStatus = '';

                    fetch(formUrl, {
                        method: form.method,
                        body: formData,
                        signal: controller.signal
                    }).then(response => {
                        if (response.redirected) {
                            // handle redirect
                            this.moduleInstance.call('goTo', { 'url': response.url }, 'Load')

                            controller.abort();
                        }

                        responseStatus = response.status

                        return response.json()
                    }).then(response => {
                        const {
                            errors,
                            message,
                            next
                        } = response

                        if (errors) {
                            // clone response errors messages (this is to keep messages regardless of validation state)
                            this.serverErrorMessages = { ...errors }
                            this.serverErrors = errors
                            // trigger validation update
                            this.$v.$touch()

                            this.formState = STATE.ERRORED
                            // Scroll to top of form
                            this.moduleInstance && this.moduleInstance.call('scrollTo', [ this.$el ], 'Scroll')
                        }

                        this.formFeedback = message || null

                        if (next) {
                            try {
                                isDebug && console.log('[App.Form.submitForm] Page substitution by a feedback url…')
                                const url = new URL(window.location.href)
                                url.pathname = next
                                this.moduleInstance && this.moduleInstance.call('refresh', { url }, 'Load')
                                return
                            } catch (e) {
                                isDebug && console.error('[App.Form.submitForm] Couldn’t transition to feedback', e)
                                this.formState = STATE.ERRORED
                                // TODO add contact url
                                this.formFeedback = GENERIC_MESSAGES.redirect
                            }
                        }
                    }).catch(error => {
                        console.error('[App.Form.submitForm]', error)
                        this.formState = STATE.ERRORED
                        // TODO add contact url
                        this.formFeedback = GENERIC_MESSAGES.critical
                    })
                },

                setInitialValues(values) {
                    // Add data into each step
                    values.forEach((stepObj, index) => {
                        const step = this[`step${index + 1}`]
                        if (step) {
                            this[`step${index + 1}`] = {...step , ...stepObj }
                        }
                    })
                }
            }
        });
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
